import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ContactsService } from 'libs/data/contacts/src/lib/services/contacts.service';
import { map } from 'rxjs';

@Component({
  selector: 'epc-searchable-business-contacts',
  templateUrl: './searchable-business-contacts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SearchableBusinessContactsComponent {
  protected readonly isLoading$ = this.contactsService.isLoading$;
  protected readonly contacts$ = this.contactsService.contacts$.pipe(
    map((contacts) =>
      [...(contacts ?? [])].sort((a, b) =>
        a.displayName.localeCompare(b.displayName),
      ),
    ),
  );

  constructor(private readonly contactsService: ContactsService) {}
}
